// RITM1147493
import { Accordion, AccordionItem, Table, TableBody, TableCell, TableContainer, TableHead, TableHeader, TableRow } from "carbon-components-react";
import React from "react";

export default function HighConsequenceLevelLegend() {
	return (
		<Accordion className="legenda">
			<AccordionItem className="" title="Legenda">
				<TableContainer>
					<Table className="legend-mobile">
						<TableHead>
							<TableRow>
								<TableHeader colSpan={9}>Actual High Consequence Level on People</TableHeader>
							</TableRow>
							<TableRow>
								<TableHeader colSpan={1} rowspan={2}>High-Consequence Level</TableHeader>
								<TableHeader colSpan={2} rowspan={2}>Severity</TableHeader>
								<TableHeader colSpan={2} rowspan={2}>Duration</TableHeader>
								<TableHeader colSpan={4}>Actual Consequence: Injury Examples</TableHeader>
							</TableRow>
							<TableRow>
								<TableHeader colSpan={4}>(List notates a typical level for injury type – not exhaustive)</TableHeader>
							</TableRow>
						</TableHead>
						<TableBody>
							<TableRow key="1" className="gray">
								<TableCell colSpan={1} key="1.1">5</TableCell>
								<TableCell colSpan={2} key="1.2">Multiple Fatality</TableCell>
								<TableCell colSpan={2} key="1.3">Death</TableCell>
								<TableCell colSpan={4} key="1.4">•	Multiple Fatalities</TableCell>
							</TableRow>
							<TableRow key="2" className="gray">
								<TableCell colSpan={1} key="2.1">4</TableCell>
								<TableCell colSpan={2} key="2.2">Fatality</TableCell>
								<TableCell colSpan={2} key="2.3">Death</TableCell>
								<TableCell colSpan={4} key="2.4">•	Fatality</TableCell>
							</TableRow>
							<TableRow key="3" className="gray">
								<TableCell colSpan={1} rowspan={8} key="3.1">3</TableCell>
								<TableCell colSpan={2} rowspan={8} key="3.2">Life-altering and severe impact to daily activities</TableCell>
								<TableCell colSpan={2} rowspan={8} key="3.3">Long-term / Years / Forever</TableCell>
								<TableCell colSpan={4} key="3.4">•	Debilitating laceration / sprain / strain</TableCell>
							</TableRow>
							<TableRow key="4" className="gray">
								<TableCell colSpan={4} key="4.4">•	Severe compound bone fracture</TableCell>
							</TableRow>
							<TableRow key="5" className="gray">
								<TableCell colSpan={4} key="5.4">•	Debilitating partial and full thickness burns</TableCell>
							</TableRow>
							<TableRow key="6" className="gray">
								<TableCell colSpan={4} key="6.4">•	Amputation with complete loss of any bone</TableCell>
							</TableRow>
							<TableRow key="7" className="gray">
								<TableCell colSpan={4} key="7.4">•	Finger amputation</TableCell>
							</TableRow>
							<TableRow key="8" className="gray">
								<TableCell colSpan={4} key="8.4">•	Severe disfigurement</TableCell>
							</TableRow>
							<TableRow key="9" className="gray">
								<TableCell colSpan={4} key="9.4">•	Loss of organ function</TableCell>
							</TableRow>
							<TableRow key="10" className="gray">
								<TableCell colSpan={4} key="10.4">•	Severe vision loss / blindness in an eye(s)</TableCell>
							</TableRow>
							<TableRow key="11" className="gray">
								<TableCell colSpan={1} rowspan={7} key="11.1">2</TableCell>
								<TableCell colSpan={2} rowspan={7} key="11.2">Moderate impact to daily activities</TableCell>
								<TableCell colSpan={2} rowspan={7} key="11.3">Week(s) to Months to Recover</TableCell>
								<TableCell colSpan={4} key="11.4">•	Significant laceration, penetration</TableCell>
							</TableRow>
							<TableRow key="12" className="gray">
								<TableCell colSpan={4} key="12.4">•	Significant strain or sprain</TableCell>
							</TableRow>
							<TableRow key="13" className="gray">
								<TableCell colSpan={4} key="13.4">•	Bone fracture without long-term issues</TableCell>
							</TableRow>
							<TableRow key="14" className="gray">
								<TableCell colSpan={4} key="14.4">•	Cracked or loss of tooth (teeth)</TableCell>
							</TableRow>
							<TableRow key="15" className="gray">
								<TableCell colSpan={4} key="15.4">•	Joint dislocation</TableCell>
							</TableRow>
							<TableRow key="16" className="gray">
								<TableCell colSpan={4} key="16.4">•	Deep partial or full thickness burns</TableCell>
							</TableRow>
							<TableRow key="17" className="gray">
								<TableCell colSpan={4} key="17.4">•	Minor-to-moderate vision loss in an eye(s)</TableCell>
							</TableRow>
							<TableRow key="18" className="gray">
								<TableCell colSpan={1} rowspan={8} key="18.1">1</TableCell>
								<TableCell colSpan={2} rowspan={8} key="18.2">Minor impact to daily activities</TableCell>
								<TableCell colSpan={2} rowspan={8} key="18.3">Minutes-Hours-Days</TableCell>
								<TableCell colSpan={4} key="18.4">•	Minor laceration, penetration, scratch</TableCell>
							</TableRow>
							<TableRow key="19" className="gray">
								<TableCell colSpan={4} key="19.4">•	Minor strain, sprain, bruising, swelling</TableCell>
							</TableRow>
							<TableRow key="20" className="gray">
								<TableCell colSpan={4} key="20.4">•	Minor burns</TableCell>
							</TableRow>
							<TableRow key="21" className="gray">
								<TableCell colSpan={4} key="21.4">•	Slight-to-mild abrasion of corneal / UV Keratitis</TableCell>
							</TableRow>
							<TableRow key="22" className="gray">
								<TableCell colSpan={4} key="22.4">•	Minor chipping of tooth / enamel</TableCell>
							</TableRow>
							<TableRow key="23" className="gray">
								<TableCell colSpan={4} key="23.4">•	Minor fracture of distal phalanx (finger or toe)</TableCell>
							</TableRow>
							<TableRow key="24" className="gray">
								<TableCell colSpan={4} key="24.4">•	Subungual hematoma (blood under nail)</TableCell>
							</TableRow>
							<TableRow key="25" className="gray">
								<TableCell colSpan={4} key="25.4">•	Anaphylactic Reactions</TableCell>
							</TableRow>
							<TableRow key="26" className="gray">
								<TableCell colSpan={1} rowspan={8} key="26.1">0</TableCell>
								<TableCell colSpan={2} rowspan={8} key="26.2">No significant impact to daily activities</TableCell>
								<TableCell colSpan={2} rowspan={8} key="26.3">No Physical Body Damage</TableCell>
								<TableCell colSpan={4} key="26.4">•	Slight skin abrasion/scratch with no bleeding</TableCell>
							</TableRow>
							<TableRow key="27" className="gray">
								<TableCell colSpan={4} key="27.4">•	First-degree skin burns; no blistering</TableCell>
							</TableRow>
							<TableRow key="28" className="gray">
								<TableCell colSpan={4} key="28.4">•	Foreign object in eye but no corneal abrasion</TableCell>
							</TableRow>
							<TableRow key="29" className="gray">
								<TableCell colSpan={4} key="29.4">•	Slip / Trip / Fall without bruising or swelling</TableCell>
							</TableRow>
							<TableRow key="30" className="gray">
								<TableCell colSpan={4} key="30.4">•	General muscle soreness, tweaks, body aches</TableCell>
							</TableRow>
							<TableRow key="31" className="gray">
								<TableCell colSpan={4} key="31.4">•	Temporary Discomfort Event (body aches, etc.)</TableCell>
							</TableRow>
							<TableRow key="32" className="gray">
								<TableCell colSpan={4} key="32.4">•	Mild shock from static electricity</TableCell>
							</TableRow>
							<TableRow key="33" className="gray">
								<TableCell colSpan={4} key="33.4">•	Mild Oxygen Hypoxia / Deficiency</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</TableContainer>
				<br/>
				<TableContainer>
					<Table className="legend-mobile">
						<TableHead>
							<TableRow>
								<TableHeader colSpan={9}>Actual High Consequence Level on Environment</TableHeader>
							</TableRow>
							<TableRow>
								<TableHeader colSpan={1}>Environmental Level</TableHeader>
								<TableHeader colSpan={2}>Severity</TableHeader>
								<TableHeader colSpan={2}>Description</TableHeader>
								<TableHeader colSpan={4}>Actual /Potential Environmental Consequence: Examples</TableHeader>
							</TableRow>
						</TableHead>
						<TableBody>
							<TableRow key="1" className="gray">
								<TableCell colSpan={1} key="1.1">5</TableCell>
								<TableCell colSpan={2} key="1.2">Catastrophic</TableCell>
								<TableCell colSpan={2} key="1.3">Incidents causing catastrophic environmental damage, such as natural or industrial disasters leading to irreversible changes in ecosystems, species extinction, and severe risks to human health.</TableCell>
								<TableCell colSpan={4} key="1.4">A major industrial disaster, such as a chemical plant explosion, leading to widespread contamination, irreversible changes in ecosystems, species extinction, and severe health risks for the local population.</TableCell>
							</TableRow>
							<TableRow key="2" className="gray">
								<TableCell colSpan={1} key="2.1">4</TableCell>
								<TableCell colSpan={2} key="2.2">Very Severe</TableCell>
								<TableCell colSpan={2} key="2.3">Incidents causing very severe environmental damage, such as soil or water contamination requiring years of remediation and potentially compromising human and ecosystem health.</TableCell>
								<TableCell colSpan={4} key="2.4">Soil contamination from a significant leak of industrial waste, requiring years of remediation and posing risks to human health and local wildlife.</TableCell>
							</TableRow>
							<TableRow key="3" className="gray">
								<TableCell colSpan={1} key="3.1">3</TableCell>
								<TableCell colSpan={2} key="3.2">Severe</TableCell>
								<TableCell colSpan={2} key="3.3">Incidents causing severe environmental damage, such as large spills of hazardous substances requiring extensive cleanup efforts and potentially having long-term effects on flora and fauna.</TableCell>
								<TableCell colSpan={4} key="3.4">A large spill of a hazardous chemical into a river, requiring extensive cleanup efforts and potentially causing long-term effects on aquatic life and water quality.</TableCell>
							</TableRow>
							<TableRow key="4" className="gray">
								<TableCell colSpan={1} key="4.1">2</TableCell>
								<TableCell colSpan={2} key="4.2">Moderate</TableCell>
								<TableCell colSpan={2} key="4.3">Incidents causing significant but temporary environmental damage, such as spills of hazardous substances requiring cleanup efforts but not causing long-term harm to ecosystems.</TableCell>
								<TableCell colSpan={4} key="4.4">A spill of a hazardous substance, such as a small amount of oil, that requires cleanup efforts but does not cause long-term harm to the local ecosystem.</TableCell>
							</TableRow>
							<TableRow key="5" className="gray">
								<TableCell colSpan={1} key="5.1">1</TableCell>
								<TableCell colSpan={2} key="5.2">Minor</TableCell>
								<TableCell colSpan={2} key="5.3">Incidents causing minor environmental damage, such as small spills of non-hazardous substances that can be easily contained and cleaned up without lasting effects.</TableCell>
								<TableCell colSpan={4} key="5.4">A small spill of non-hazardous cleaning solution that is quickly contained and cleaned up without any lasting effects on the environment.</TableCell>
							</TableRow>
							<TableRow key="6" className="gray">
								<TableCell colSpan={1} key="6.1">0</TableCell>
								<TableCell colSpan={2} key="6.2">No consequence</TableCell>
								<TableCell colSpan={2} key="6.3">Incidents or conditions that have no impact on the environment.</TableCell>
								<TableCell colSpan={4} key="6.4">A minor equipment malfunction that does not result in any release of substances or impact on the environment.</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</TableContainer>
				<br/>
				<TableContainer>
					<Table className="legend-mobile">
						<TableHead>
							<TableRow>
								<TableHeader colSpan={9}>Barrier</TableHeader>
							</TableRow>
							<TableRow>
								<TableHeader colSpan={1}>EQUIPMENT</TableHeader>
								<TableHeader colSpan={2}>PROCESSES</TableHeader>
								<TableHeader colSpan={2}>PEOPLE</TableHeader>
							</TableRow>
						</TableHead>
						<TableBody>
							<TableRow key="1" className="gray">
								<TableCell colSpan={1} key="1.1">3D model</TableCell>
								<TableCell colSpan={2} key="1.2">Access control (Watchman, Rack for badge, etc.)</TableCell>
								<TableCell colSpan={2} key="1.3">100% tied off</TableCell>
							</TableRow>
							<TableRow key="2" className="gray">
								<TableCell colSpan={1} key="2.1">Access/egress</TableCell>
								<TableCell colSpan={2} key="2.2">Alcohol/drug test</TableCell>
								<TableCell colSpan={2} key="2.3">After Action Review</TableCell>
							</TableRow>
							<TableRow key="3" className="gray">
								<TableCell colSpan={1} key="3.1">AI Smart Camera</TableCell>
								<TableCell colSpan={2} key="3.2">Cable management and protection from damage</TableCell>
								<TableCell colSpan={2} key="3.3">Authorized people identified</TableCell>
							</TableRow>
							<TableRow key="4" className="gray">
								<TableCell colSpan={1} key="4.1">Air bag set</TableCell>
								<TableCell colSpan={2} key="4.2">Car data monitoring (IVMS, camera, etc..)</TableCell>
								<TableCell colSpan={2} key="4.3">Certified operator (excavator, loader, etc..)</TableCell>
							</TableRow>
							<TableRow key="5" className="gray">
								<TableCell colSpan={1} key="5.1">Anchor Points-lifelines</TableCell>
								<TableCell colSpan={2} key="5.2">Certified electrical system installed</TableCell>
								<TableCell colSpan={2} key="5.3">Certified platform operator</TableCell>
							</TableRow>
							<TableRow key="6" className="gray">
								<TableCell colSpan={1} key="6.1">Anti collision system (for excavator, loader, etc..)</TableCell>
								<TableCell colSpan={2} key="6.2">Color code system</TableCell>
								<TableCell colSpan={2} key="6.3">Certified electrician</TableCell>
							</TableRow>
							<TableRow key="7" className="gray">
								<TableCell colSpan={1} key="7.1">Antifatigue system installed</TableCell>
								<TableCell colSpan={2} key="7.2">Color code system for lifting gears</TableCell>
								<TableCell colSpan={2} key="7.3">Certified equipment (Manlift , etc..)</TableCell>
							</TableRow>
							<TableRow key="8" className="gray">
								<TableCell colSpan={1} key="8.1">Area Isolation (fire blanket, sparks containment barriers)</TableCell>
								<TableCell colSpan={2} key="8.2">Communication protocol in place</TableCell>
								<TableCell colSpan={2} key="8.3">Certified or Trained Gas Tester</TableCell>
							</TableRow>
							<TableRow key="9" className="gray">
								<TableCell colSpan={1} key="9.1">Barricade</TableCell>
								<TableCell colSpan={2} key="9.2">Confined space procedure</TableCell>
								<TableCell colSpan={2} key="9.3">Certified Rescue team</TableCell>
							</TableRow>
							<TableRow key="10" className="gray">
								<TableCell colSpan={1} key="10.1">Camera on board</TableCell>
								<TableCell colSpan={2} key="10.2">Daily check list</TableCell>
								<TableCell colSpan={2} key="10.3">Certified/Competent scaffolder</TableCell>
							</TableRow>
							<TableRow key="11" className="gray">
								<TableCell colSpan={1} key="11.1">Certified electrical equipments</TableCell>
								<TableCell colSpan={2} key="11.2">Daily check list done by crane operator</TableCell>
								<TableCell colSpan={2} key="11.3">Competent Lifting equipment inspector</TableCell>
							</TableRow>
							<TableRow key="12" className="gray">
								<TableCell colSpan={1} key="12.1">Certified electrical system installed</TableCell>
								<TableCell colSpan={2} key="12.2">Daily checklist done by operator(Manlift, etc..)</TableCell>
								<TableCell colSpan={2} key="12.3">Competent people (Civil Engineer, Supervisor, Superintendent) to manage the excavation activities</TableCell>
							</TableRow>
							<TableRow key="13" className="gray">
								<TableCell colSpan={1} key="13.1">Certified equipment (loader, excavator, truck)</TableCell>
								<TableCell colSpan={2} key="13.2">daily ptw/simops meeting</TableCell>
								<TableCell colSpan={2} key="13.3">Competent people (Mechanical, electrical, etc..)</TableCell>
							</TableRow>
							<TableRow key="14" className="gray">
								<TableCell colSpan={1} key="14.1">Certified Rescue equipment (tripod, trolley, etc..)</TableCell>
								<TableCell colSpan={2} key="14.2">Dedicated info regarding the designated and responsible persons that oversee  the safety system (including picture, contact detail)</TableCell>
								<TableCell colSpan={2} key="14.3">Crane Operator Certificate</TableCell>
							</TableRow>
							<TableRow key="15" className="gray">
								<TableCell colSpan={1} key="15.1">Chain</TableCell>
								<TableCell colSpan={2} key="15.2">Dedicated MOC (Management of change) in case bypassing it's necessary and not planned</TableCell>
								<TableCell colSpan={2} key="15.3">Crane Operator Competence</TableCell>
							</TableRow>
							<TableRow key="16" className="gray">
								<TableCell colSpan={1} key="16.1">Crane Certificate</TableCell>
								<TableCell colSpan={2} key="16.2">Electrical panel locked and Responsible electrical person clear identified with picture and contact detail</TableCell>
								<TableCell colSpan={2} key="16.3">Crane Operator Training</TableCell>
							</TableRow>
							<TableRow key="17" className="gray">
								<TableCell colSpan={1} key="17.1">Crane Inspection (periodic by Third party)</TableCell>
								<TableCell colSpan={2} key="17.2">Emergency Plan</TableCell>
								<TableCell colSpan={2} key="17.3">Dedicated personnel for PTW dpt</TableCell>
							</TableRow>
							<TableRow key="18" className="gray">
								<TableCell colSpan={1} key="18.1">Crane Maintenance</TableCell>
								<TableCell colSpan={2} key="18.2">Equipment maintenance</TableCell>
								<TableCell colSpan={2} key="18.3">Designated and competent people to perform the work</TableCell>
							</TableRow>
							<TableRow key="19" className="gray">
								<TableCell colSpan={1} key="19.1">Dead-man switch installed on grinding machine</TableCell>
								<TableCell colSpan={2} key="19.2">Excavation procedure or Method Statement</TableCell>
								<TableCell colSpan={2} key="19.3">Driving certificate</TableCell>
							</TableRow>
							<TableRow key="20" className="gray">
								<TableCell colSpan={1} key="20.1">Earthing system</TableCell>
								<TableCell colSpan={2} key="20.2">Gas Test</TableCell>
								<TableCell colSpan={2} key="20.3">Flagmen, banksmen in place during moving equipments activities</TableCell>
							</TableRow>
							<TableRow key="21" className="gray">
								<TableCell colSpan={1} key="21.1">Electrical equipment Low Voltage</TableCell>
								<TableCell colSpan={2} key="21.2">Gas Test (Explosivity) before or continuous (when required)</TableCell>
								<TableCell colSpan={2} key="21.3">Maintain 3 points of contact</TableCell>
							</TableRow>
							<TableRow key="22" className="gray">
								<TableCell colSpan={1} key="22.1">E-PTW or APP or Digital tools</TableCell>
								<TableCell colSpan={2} key="22.2">Ground condition assessment before lift (inclination, soil compaction, etc..)</TableCell>
								<TableCell colSpan={2} key="22.3">Medical fitness certificate</TableCell>
							</TableRow>
							<TableRow key="23" className="gray">
								<TableCell colSpan={1} key="23.1">Equipment Inspection</TableCell>
								<TableCell colSpan={2} key="23.2">Journey management</TableCell>
								<TableCell colSpan={2} key="23.3">Only authorized people</TableCell>
							</TableRow>
							<TableRow key="24" className="gray">
								<TableCell colSpan={1} key="24.1">Exclusion zone</TableCell>
								<TableCell colSpan={2} key="24.2">Lifting Plan, Lifting procedure, Method Statements</TableCell>
								<TableCell colSpan={2} key="24.3">Refresh training (each 6 moths, year)</TableCell>
							</TableRow>
							<TableRow key="25" className="gray">
								<TableCell colSpan={1} key="25.1">Fall protection</TableCell>
								<TableCell colSpan={2} key="25.2">LO-TO procedure</TableCell>
								<TableCell colSpan={2} key="25.3">Rescue team in place</TableCell>
							</TableRow>
							<TableRow key="26" className="gray">
								<TableCell colSpan={1} key="26.1">Fire extinguisher</TableCell>
								<TableCell colSpan={2} key="26.2">Periodical inspection (daily, weekly, etc.)</TableCell>
								<TableCell colSpan={2} key="26.3">Rigger Certificate</TableCell>
							</TableRow>
							<TableRow key="27" className="gray">
								<TableCell colSpan={1} key="27.1">Firex</TableCell>
								<TableCell colSpan={2} key="27.2">Periodical inspection by competent electrician</TableCell>
								<TableCell colSpan={2} key="27.3">Rigger Competence</TableCell>
							</TableRow>
							<TableRow key="28" className="gray">
								<TableCell colSpan={1} key="28.1">Flammable material protection</TableCell>
								<TableCell colSpan={2} key="28.2">Periodical inspection Safety Harnesses</TableCell>
								<TableCell colSpan={2} key="28.3">Rigger Training</TableCell>
							</TableRow>
							<TableRow key="29" className="gray">
								<TableCell colSpan={1} key="29.1">Flashback arrestor valve installed on oxygen and acetylene hoses</TableCell>
								<TableCell colSpan={2} key="29.2">Periodical test of GFCI</TableCell>
								<TableCell colSpan={2} key="29.3">Safe driving training</TableCell>
							</TableRow>
							<TableRow key="30" className="gray">
								<TableCell colSpan={1} key="30.1">Gas Cylinders properly stored</TableCell>
								<TableCell colSpan={2} key="30.2">Pre-start checklist or Self verification</TableCell>
								<TableCell colSpan={2} key="30.3">Scaffolder Advisor/Inspector in the HSE Orgchart</TableCell>
							</TableRow>
							<TableRow key="31" className="gray">
								<TableCell colSpan={1} key="31.1">GFCI (Ground fault circuit interrupter) system installed</TableCell>
								<TableCell colSpan={2} key="31.2">PTW</TableCell>
								<TableCell colSpan={2} key="31.3">Specific medical fitness certificate</TableCell>
							</TableRow>
							<TableRow key="32" className="gray">
								<TableCell colSpan={1} key="32.1">Hard barricade</TableCell>
								<TableCell colSpan={2} key="32.2">PTW and JSA</TableCell>
								<TableCell colSpan={2} key="32.3">Stop Work Authority</TableCell>
							</TableRow>
							<TableRow key="33" className="gray">
								<TableCell colSpan={1} key="33.1">Harnesses (smart)</TableCell>
								<TableCell colSpan={2} key="33.2">PTW procedure</TableCell>
								<TableCell colSpan={2} key="33.3">Supervisor, HSE Officer and Foramen available on work site</TableCell>
							</TableRow>
							<TableRow key="34" className="gray">
								<TableCell colSpan={1} key="34.1">Harnesses Certificate</TableCell>
								<TableCell colSpan={2} key="34.2">Red spade register</TableCell>
								<TableCell colSpan={2} key="34.3">Trained banksmen</TableCell>
							</TableRow>
							<TableRow key="35" className="gray">
								<TableCell colSpan={1} key="35.1">Harnesses Inspections</TableCell>
								<TableCell colSpan={2} key="35.2">Regular maintenance</TableCell>
								<TableCell colSpan={2} key="35.3">Trained Fire Watchman</TableCell>
							</TableRow>
							<TableRow key="36" className="gray">
								<TableCell colSpan={1} key="36.1">Invigilo</TableCell>
								<TableCell colSpan={2} key="36.2">Regular maintenance of equipments</TableCell>
								<TableCell colSpan={2} key="36.3">Trained personnel</TableCell>
							</TableRow>
							<TableRow key="37" className="gray">
								<TableCell colSpan={1} key="37.1">IVMS system</TableCell>
								<TableCell colSpan={2} key="37.2">Rescue Plan</TableCell>
								<TableCell colSpan={2} key="37.3">Trained Signalmen</TableCell>
							</TableRow>
							<TableRow key="38" className="gray">
								<TableCell colSpan={1} key="38.1">Lifting Gear Certificate</TableCell>
								<TableCell colSpan={2} key="38.2">Scaffold procedure (including erection/dismntling/modifying, scafftag, etc..)</TableCell>
								<TableCell colSpan={2} key="38.3">Training</TableCell>
							</TableRow>
							<TableRow key="39" className="gray">
								<TableCell colSpan={1} key="39.1">Locker</TableCell>
								<TableCell colSpan={2} key="39.2">Simops procedure</TableCell>
								<TableCell colSpan={2} key="39.3">Truck driver with proper driving license</TableCell>
							</TableRow>
							<TableRow key="40" className="gray">
								<TableCell colSpan={1} key="40.1">Locker installed</TableCell>
								<TableCell colSpan={2} key="40.2">Slope inclination method according with geotechnical report</TableCell>
								<TableCell colSpan={2} key="40.3">Workers Training</TableCell>
							</TableRow>
							<TableRow key="41" className="gray">
								<TableCell colSpan={1} key="41.1">Manlift (MEWP) /Aerial Lift Platform</TableCell>
								<TableCell colSpan={2} key="41.2">Specific communication protocol</TableCell>
								<TableCell colSpan={2} key="41.3"></TableCell>
							</TableRow>
							<TableRow key="42" className="gray">
								<TableCell colSpan={1} key="42.1">Mock up installed to brief on Line of fire typical situation</TableCell>
								<TableCell colSpan={2} key="42.2">Specific communication protocol (people are aware about the safety system present in their worklocation)</TableCell>
								<TableCell colSpan={2} key="42.3"></TableCell>
							</TableRow>
							<TableRow key="43" className="gray">
								<TableCell colSpan={1} key="43.1">Multigas detector certified and regularly calibrated</TableCell>
								<TableCell colSpan={2} key="43.2">Specific safety campaign</TableCell>
								<TableCell colSpan={2} key="43.3"></TableCell>
							</TableRow>
							<TableRow key="44" className="gray">
								<TableCell colSpan={1} key="44.1">Multigas detector certified and regularly calibrated (when required)</TableCell>
								<TableCell colSpan={2} key="44.2">Sufficient number of Supervision in place (Supervisor and Foramen in proper ratio)</TableCell>
								<TableCell colSpan={2} key="44.3"></TableCell>
							</TableRow>
							<TableRow key="45" className="gray">
								<TableCell colSpan={1} key="45.1">P&I available</TableCell>
								<TableCell colSpan={2} key="45.2">Tool box talk</TableCell>
								<TableCell colSpan={2} key="45.3"></TableCell>
							</TableRow>
							<TableRow key="46" className="gray">
								<TableCell colSpan={1} key="46.1">Pedestrian way installed</TableCell>
								<TableCell colSpan={2} key="46.2">Transition phase procedure in place (from Construction to Pre-Comm/Comm phase)</TableCell>
								<TableCell colSpan={2} key="46.3"></TableCell>
							</TableRow>
							<TableRow key="47" className="gray">
								<TableCell colSpan={1} key="47.1">Portable electrical tool with double insulation</TableCell>
								<TableCell colSpan={2} key="47.2"></TableCell>
								<TableCell colSpan={2} key="47.3"></TableCell>
							</TableRow>
							<TableRow key="48" className="gray">
								<TableCell colSpan={1} key="48.1">PPEs</TableCell>
								<TableCell colSpan={2} key="48.2"></TableCell>
								<TableCell colSpan={2} key="48.3"></TableCell>
							</TableRow>
							<TableRow key="49" className="gray">
								<TableCell colSpan={1} key="49.1">PPEs (gloves, helmet,..)</TableCell>
								<TableCell colSpan={2} key="49.2"></TableCell>
								<TableCell colSpan={2} key="49.3"></TableCell>
							</TableRow>
							<TableRow key="50" className="gray">
								<TableCell colSpan={1} key="50.1">Proper car (4x4 for mountain or similar)</TableCell>
								<TableCell colSpan={2} key="50.2"></TableCell>
								<TableCell colSpan={2} key="50.3"></TableCell>
							</TableRow>
							<TableRow key="51" className="gray">
								<TableCell colSpan={1} key="51.1">Proper safety sign (clear identification and prohibition)  installed on safety control system (multilanguage)</TableCell>
								<TableCell colSpan={2} key="51.2"></TableCell>
								<TableCell colSpan={2} key="51.3"></TableCell>
							</TableRow>
							<TableRow key="52" className="gray">
								<TableCell colSpan={1} key="52.1">Push pull stick</TableCell>
								<TableCell colSpan={2} key="52.2"></TableCell>
								<TableCell colSpan={2} key="52.3"></TableCell>
							</TableRow>
							<TableRow key="53" className="gray">
								<TableCell colSpan={1} key="53.1">Radio</TableCell>
								<TableCell colSpan={2} key="53.2"></TableCell>
								<TableCell colSpan={2} key="53.3"></TableCell>
							</TableRow>
							<TableRow key="54" className="gray">
								<TableCell colSpan={1} key="54.1">Radio when needed</TableCell>
								<TableCell colSpan={2} key="54.2"></TableCell>
								<TableCell colSpan={2} key="54.3"></TableCell>
							</TableRow>
							<TableRow key="55" className="gray">
								<TableCell colSpan={1} key="55.1">Red Spade</TableCell>
								<TableCell colSpan={2} key="55.2"></TableCell>
								<TableCell colSpan={2} key="55.3"></TableCell>
							</TableRow>
							<TableRow key="56" className="gray">
								<TableCell colSpan={1} key="56.1">Safety harnesses with positioning lanyard for MEWP</TableCell>
								<TableCell colSpan={2} key="56.2"></TableCell>
								<TableCell colSpan={2} key="56.3"></TableCell>
							</TableRow>
							<TableRow key="57" className="gray">
								<TableCell colSpan={1} key="57.1">Safety Sign board (Multi language)</TableCell>
								<TableCell colSpan={2} key="57.2"></TableCell>
								<TableCell colSpan={2} key="57.3"></TableCell>
							</TableRow>
							<TableRow key="58" className="gray">
								<TableCell colSpan={1} key="58.1">Safety system installed (fire&gas, etc..)</TableCell>
								<TableCell colSpan={2} key="58.2"></TableCell>
								<TableCell colSpan={2} key="58.3"></TableCell>
							</TableRow>
							<TableRow key="59" className="gray">
								<TableCell colSpan={1} key="59.1">Scaffold Platform</TableCell>
								<TableCell colSpan={2} key="59.2"></TableCell>
								<TableCell colSpan={2} key="59.3"></TableCell>
							</TableRow>
							<TableRow key="60" className="gray">
								<TableCell colSpan={1} key="60.1">SCBA apparatus</TableCell>
								<TableCell colSpan={2} key="60.2"></TableCell>
								<TableCell colSpan={2} key="60.3"></TableCell>
							</TableRow>
							<TableRow key="61" className="gray">
								<TableCell colSpan={1} key="61.1">Sealt belt</TableCell>
								<TableCell colSpan={2} key="61.2"></TableCell>
								<TableCell colSpan={2} key="61.3"></TableCell>
							</TableRow>
							<TableRow key="62" className="gray">
								<TableCell colSpan={1} key="62.1">Shore protection system</TableCell>
								<TableCell colSpan={2} key="62.2"></TableCell>
								<TableCell colSpan={2} key="62.3"></TableCell>
							</TableRow>
							<TableRow key="63" className="gray">
								<TableCell colSpan={1} key="63.1">Sparks arrestors</TableCell>
								<TableCell colSpan={2} key="63.2"></TableCell>
								<TableCell colSpan={2} key="63.3"></TableCell>
							</TableRow>
							<TableRow key="64" className="gray">
								<TableCell colSpan={1} key="64.1">Tag-lines</TableCell>
								<TableCell colSpan={2} key="64.2"></TableCell>
								<TableCell colSpan={2} key="64.3"></TableCell>
							</TableRow>
							<TableRow key="65" className="gray">
								<TableCell colSpan={1} key="65.1">Tyre fit for the proper road</TableCell>
								<TableCell colSpan={2} key="65.2"></TableCell>
								<TableCell colSpan={2} key="65.3"></TableCell>
							</TableRow>
							<TableRow key="66" className="gray">
								<TableCell colSpan={1} key="66.1">Underground service identification (plot plan available,etc..)</TableCell>
								<TableCell colSpan={2} key="66.2"></TableCell>
								<TableCell colSpan={2} key="66.3"></TableCell>
							</TableRow>
							<TableRow key="67" className="gray">
								<TableCell colSpan={1} key="67.1">Use of Table or Smartphone</TableCell>
								<TableCell colSpan={2} key="67.2"></TableCell>
								<TableCell colSpan={2} key="67.3"></TableCell>
							</TableRow>
							<TableRow key="" className="gray">
								<TableCell colSpan={1} key="68.1">Ventilation system</TableCell>
								<TableCell colSpan={2} key="68.2"></TableCell>
								<TableCell colSpan={2} key="68.3"></TableCell>
							</TableRow>
							<TableRow key="69" className="gray">
								<TableCell colSpan={1} key="69.1">Video monitoring from external</TableCell>
								<TableCell colSpan={2} key="69.2"></TableCell>
								<TableCell colSpan={2} key="69.3"></TableCell>
							</TableRow>
							<TableRow key="70" className="gray">
								<TableCell colSpan={1} key="70.1">Well point system</TableCell>
								<TableCell colSpan={2} key="70.2"></TableCell>
								<TableCell colSpan={2} key="70.3"></TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</TableContainer>
			</AccordionItem>
		</Accordion>
	);
}
